angular.module( 'angus.directives' ).directive( 'appDeliveryHistory', [
	'actionViewTemplates',
	function( actionViewTemplates ) {
		return {
			scope: {
				closeCb: "=",
				model: "=actionModel",
				widgetSettings: "=deliveryHistoryWidgetInstance"
			},
			templateUrl: actionViewTemplates.deliveryHistoryReportContainer
		};
	}
] );